import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { CalendarComponent } from './calendar/calendar.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { FooterComponent } from './footer/footer.component';
import { TermsComponent } from './terms/terms.component';
import { NewsComponent } from './news/news.component';
import { BlogEntryStore } from './blog/blog-entry-store';
import { PriceComponent } from './price/price.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'calendar', component: CalendarComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'news', component: NewsComponent },
  { path: 'price', component: PriceComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'terms', component: TermsComponent }
];

@NgModule({
  declarations: [
        AppComponent,
        NavMenuComponent,
        FooterComponent,
        HomeComponent,
        CalendarComponent,
        ContactComponent,
        NewsComponent,
        PrivacyComponent,
        TermsComponent,
        PriceComponent,
    ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(routes, {
        initialNavigation: 'enabledNonBlocking',
        scrollPositionRestoration: 'enabled'
    })],
  providers: [
    BlogEntryStore,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
